import { useState } from "react";
import { SDivContainer, SLinkIcon, SLinkLabel, SLinkIconSub, ToolTipMenu } from "./styles";
import IconComponent from "../../Icons";
import { OverlayTrigger } from "react-bootstrap";

function SubMenuComponent({ item, baropen, subnav }) {
    const handleClick = (itemClicked) => {
        const permissaoRotina = itemClicked.actions;
        localStorage.setItem('permissaoRotina', JSON.stringify(permissaoRotina));
    };

    return (
        <OverlayTrigger overlay={<ToolTipMenu $baropen={baropen} >{item.title}</ToolTipMenu>}>
            <SDivContainer onClick={() => handleClick(item)} $baropen={baropen} quebra={item.indice.split('.').length - 1} $isactive={false} >
                <SLinkIcon>
                    {<IconComponent icon={item.icon} />}
                    {baropen && (
                        <>
                            <SLinkLabel>{item.title}</SLinkLabel>
                            {item.subNav.length > 0 && (
                                <SLinkIconSub>
                                {subnav ? (
                                    <IconComponent icon="BiChevronUp" />
                                ) : (
                                    <IconComponent icon="BiChevronDown" />
                                )}
                                </SLinkIconSub>
                            )}
                        </>
                    )}
                </SLinkIcon>
            </SDivContainer>
        </OverlayTrigger>
    );
}

export default SubMenuComponent;
